import React from "react";
import "./Buttons.scss";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchExamInstructionRequest } from "../../../../../redux/exam/examSlice";

const Buttons = () => {
  const history = useHistory();
const dispatch = useDispatch();
const { testDetails } = useSelector((state) => state.examSlice);

  const handleReattempt = () => {
     if (!testDetails?.paperId) return;
  dispatch(fetchExamInstructionRequest(testDetails));
  history.push("/TestInstruction");
  };

  const handleSeeResponse = () => {
    history.push("/adv-analytics", { tab: "questionwise" });
  };

  return (
    <div className="basicAnalytics__buttons">
      <div
        className="basicAnalytics__buttons__button"
        onClick={handleReattempt}
      >
        Reattempt
      </div>

      <div
        className="basicAnalytics__buttons__button"
        onClick={handleSeeResponse}
      >
        See Response
      </div>
    </div>
  );
};

export default Buttons;
